import { render, staticRenderFns } from "./footerCon.vue?vue&type=template&id=3615f8fc&scoped=true&"
import script from "./footerCon.vue?vue&type=script&lang=js&"
export * from "./footerCon.vue?vue&type=script&lang=js&"
import style0 from "./footerCon.vue?vue&type=style&index=0&id=3615f8fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3615f8fc",
  null
  
)

export default component.exports